import { SlashHintNode } from '#pplx/frontend/composer-sdk/lexical/nodes/SlashHintNode.js';
import { $applyNodeReplacement } from 'lexical';
export function $createSlashHintNode(hintText) {
    return $applyNodeReplacement(new SlashHintNode(hintText));
}
export function $isSlashHintNode(node) {
    return node instanceof SlashHintNode;
}
//# sourceMappingURL=SlashHintNodeSupport.js.map